import React from 'react';

/**
 * StepIndicator — visual 1-2-3 progress.
 */
function StepIndicator({ currentStep, totalSteps, onStepClick }) {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  return (
    <div className="step-indicator">
      {steps.map((step, idx) => (
        <React.Fragment key={step}>
          <button
            className={`step-dot ${step === currentStep ? 'current' : ''} ${step < currentStep ? 'completed' : ''}`}
            onClick={() => onStepClick(step)}
            disabled={step > currentStep}
            aria-label={`Step ${step}`}
            aria-current={step === currentStep ? 'step' : undefined}
          >
            {step < currentStep ? '✓' : step}
          </button>
          {idx < steps.length - 1 && <div className="step-connector" />}
        </React.Fragment>
      ))}
    </div>
  );
}

export default StepIndicator;
